import React from 'react'

export default props => (
  <div className="flex flex-row items-center justify-center">
    <img src="/asset/image/logo.svg" height={40} width={40} alt="logo" />

    <h1 className="text-xl font-semibold text-white">OS Services</h1>
  </div>
)
